// ColorLegend.js
import React from "react";
import * as d3 from "d3";

const ColorLegend = ({ min, max, colorScale }) => {
  const height = 300; // Height of the legend
  const width = 30; // Width of the legend

  // Create a canvas element to draw the gradient
  const legendCanvas = React.useRef(null);

  React.useEffect(() => {
    const canvas = legendCanvas.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");

    const gradient = ctx.createLinearGradient(0, 0, 0, height);

    const numStops = 10;
    for (let i = 0; i < numStops; i++) {
      const value = min + (i / (numStops - 1)) * (max - min);
      gradient.addColorStop(i / (numStops - 1), colorScale(value));
    }

    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, width, height);
  }, [min, max, colorScale, height, width]);

  return (
    <div className="color-legend-container">
      <div className="legend-gradient">
        <canvas ref={legendCanvas} width={width} height={height} />
      </div>
      <div className="legend-labels">
        <span className="legend-label-top">{max.toFixed(2)}</span>
        <span className="legend-label-bottom">{min.toFixed(2)}</span>
      </div>
    </div>
  );
};

export default ColorLegend;
